export default __webpack_public_path__ + "static/media/dvtel.bbca924d.png";